import React from 'react';
import { Button } from '@mui/material';

const ErrorOutlinedButton = React.forwardRef(function ErrorOutlinedButton(props, ref) {
  return <Button ref={ref} variant="outlined" color="error" {...props} />;
});

export default ErrorOutlinedButton;
